import {
    Avatar,
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import LoadingAnimation from "../../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../../Layouts/ButtonsControlled";
import {
    BussinessLicenceInstaller,
    getAllInstaller,
    reset,
} from "../../../Redux/InstallerSlice/InstallerSlice";
import { getAllState, resetState } from "../../../Redux/StateSlice/stateSlice";

import uploadImage from "../../../Assets/images/uploadImage.png";
import { Add, CloudUpload, Delete } from "@mui/icons-material";
import { FormHeading } from "../../../Layouts/Heading";
import GoogleMaps from "../../../Layouts/GoogleMaps/GoogleMaps";

const BussinessLicense = ({ nextForm }) => {
    const { isLodaing, isSuccess, isError, errors } = useSelector(
        (state) => state.installer
    );

    const dispatch = useDispatch();

    // Get All States
    const { states } = useSelector((state) => state.AllStates);
    const AllStates = states?.data?.states;
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, [dispatch]);

    // All Installers
    const { installer } = useSelector((state) => state.installer);
    const installersVal = installer?.data || [];

    const GetallInstallersAction = async () => {
        await dispatch(getAllInstaller());
        await dispatch(reset());
    };

    useEffect(() => {
        GetallInstallersAction();
    }, [dispatch]);

    // ======================================================================
    // Start Handel All Of Method To Add && Delete && Edit Bussiness License
    // ======================================================================

    const LicenseInputs = {
        user_id: 0,
        license_number: "",
        license_type: 0,
        state_id: "",
        phone: "",
        license_expiration_date: "",
        license_img: "",
        drivers_license: "",
        liability_insurance: "",
        workers_comp_insurance: "",
        dstOffset: "",
        rawOffset:"",
        full_address: "",
        lat: "",
        lng: "",
        state_abbr: "",
    };

    const [LicenseForm, setLicenseForm] = useState([LicenseInputs]);

    const handelAddMoreLicenseForms = () => {
        let data = LicenseForm;
        data = [...LicenseForm, LicenseInputs];
        setLicenseForm(data);
    };

    const handelUpdataLicenseForm = (e, index) => {
        let data = [...LicenseForm];
        data[index][e.target.name] = e.target.value;
        setLicenseForm(data);
    };

    const handleChangeImage = (e, index) => {
        let data = [...LicenseForm];
        data[index][e.target.name] = e.currentTarget.files[0];
        setLicenseForm(data);
    };

    const handelDeleteLicenseForm = (index) => {
        let data = [...LicenseForm];
        data.splice(index, 1);
        setLicenseForm(data);
    };

    console.log(LicenseForm);

    // ======================================================================
    // End Handel All Of Method To Add && Delete && Edit Bussiness License
    // ======================================================================

    // Handle Fetch Data From Google Maps

    const handleSetValues = (
        index,
        singleAdress,
        full_address,
        zip_code,
        street,
        country,
        state,
        route,
        city,
        coordinates
    ) => {
        console.log(index);
        LicenseForm[index]["full_address"] = full_address;
        LicenseForm[index]["lat"] = coordinates.lat;
        LicenseForm[index]["lng"] = coordinates.lng;
        LicenseForm[index]["state_abbr"] = state;
        LicenseForm[index]["state"] = city;
        console.log(LicenseForm);
    };

    const formik = useFormik({
        initialValues: {
            user_id: "",
            license_number: "",
            license_type: "",
            state_id: "",
            phone: "",
            license_expiration_date: "",
            license_img: "",
            drivers_license: "",
            workers_comp_insurance: "",
            liability_insurance: "",
            full_address: "",
            lat: "",
            lng: "",
            state_abbr: "",
            dstOffset: "",
            rawOffset: "",
            timeZoneId: "",
            timeZoneName: "",
            license_holder: "",
        },

        onSubmit: async (values) => {
            const formData = new FormData();

            LicenseForm.map((license, index) => {
                formData.append(`data[${index}][user_id]`, license.user_id);
                formData.append(
                    `data[${index}][license_number]`,
                    license.license_number
                );
                formData.append(
                    `data[${index}][license_type]`,
                    license.license_type
                );
                formData.append(`data[${index}][state_id]`, license.state_id);
                formData.append(`data[${index}][phone]`, license.phone);
                formData.append(
                    `data[${index}][license_expiration_date]`,
                    license.license_expiration_date
                );
                formData.append(
                    `data[${index}][license_img]`,
                    license.license_img
                );
                formData.append(
                    `data[${index}][drivers_license]`,
                    license.drivers_license
                );
                formData.append(
                    `data[${index}][liability_insurance]`,
                    license.liability_insurance
                );
                formData.append(
                    `data[${index}][workers_comp_insurance]`,
                    license.workers_comp_insurance
                );

                formData.append(
                    `data[${index}][full_address]`,
                    license.full_address
                );
                formData.append(`data[${index}][lat]`, license.lat);
                formData.append(`data[${index}][lng]`, license.lng);
                formData.append(
                    `data[${index}][state_abbr]`,
                    license.state_abbr
                );
                formData.append(`data[${index}][dstOffset]`, license.dstOffset);
                formData.append(`data[${index}][rawOffset]`, license.rawOffset);
                formData.append(`data[${index}][timeZoneId]`, license.timeZoneId);
                formData.append(`data[${index}][timeZoneName]`, license.timeZoneName);
                formData.append(`data[${index}][license_holder]`, license.license_holder);
            });

            await dispatch(BussinessLicenceInstaller(formData));
            await dispatch(reset());
        },
    });

    useEffect(() => {
        if (isSuccess && LicenseForm[0].user_id) {
            toast.success("The Licenses has been added successfully");
            setLicenseForm([]);
            nextForm();
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                if (errors.length < 8) {
                    Object.keys(errors).forEach((key) => {
                        let error = errors[key][0];
                        toast.error(error);
                    });
                } else {
                    toast.error(errors);
                }
            }
            const resetMethod = async () => {
                await dispatch(reset());
            };
            resetMethod();
        }
    }, [dispatch, errors, isError]);

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <FormContainer>
                    <form onSubmit={formik.handleSubmit}>
                        {LicenseForm?.map((license, index) => (
                            <Card
                                style={{ padding: "15px", clear: "both" }}
                                mb={3}
                            >
                                <FormHeading> Business License </FormHeading>
                                <Grid container columns={12} spacing={3}>
                                    <Grid item mb={1} xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="license_number"
                                            name="license_number"
                                            label="Licence Number"
                                            value={license.license_number}
                                            onChange={(e) =>
                                                handelUpdataLicenseForm(
                                                    e,
                                                    index
                                                )
                                            }
                                        />
                                    </Grid>

                                    <Grid item mb={1} xs={12} md={6}>
                                        <FormControl fullWidth required={true}>
                                            <InputLabel id="demo-simple-select-label">
                                                License Type
                                            </InputLabel>
                                            <Select
                                                id="license_type"
                                                name="license_type"
                                                label="License Type"
                                                required
                                                value={license.license_type}
                                                onChange={(e) =>
                                                    handelUpdataLicenseForm(
                                                        e,
                                                        index
                                                    )
                                                }
                                            >
                                                <MenuItem value={1}>
                                                    Roofing
                                                </MenuItem>
                                                <MenuItem value={2}>
                                                    HVAC
                                                </MenuItem>
                                                <MenuItem value={3}>
                                                    Electrical
                                                </MenuItem>
                                                <MenuItem value={4}>
                                                    Solar
                                                </MenuItem>
                                                <MenuItem value={5}>
                                                    General
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item mb={1} xs={12} md={6}>
                                        <FormControl fullWidth required={true}>
                                            <InputLabel id="demo-simple-select-label">
                                                State
                                            </InputLabel>
                                            <Select
                                                id="state_id"
                                                name="state_id"
                                                label="State"
                                                required
                                                value={license.state_id}
                                                onChange={(e) =>
                                                    handelUpdataLicenseForm(
                                                        e,
                                                        index
                                                    )
                                                }
                                            >
                                                {AllStates?.map((key) => (
                                                    <MenuItem
                                                        key={key.id}
                                                        value={key.id}
                                                    >
                                                        {key.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item mb={1} xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="phone"
                                            name="phone"
                                            label="Phone"
                                            value={license.phone}
                                            onChange={(e) =>
                                                handelUpdataLicenseForm(
                                                    e,
                                                    index
                                                )
                                            }
                                        />
                                    </Grid>

                                    <Grid item mb={1} xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="license_expiration_date"
                                            name="license_expiration_date"
                                            label="Licence Expiration date"
                                            type="date"
                                            value={
                                                license.license_expiration_date
                                            }
                                            onChange={(e) =>
                                                handelUpdataLicenseForm(
                                                    e,
                                                    index
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <GoogleMaps
                                            index={index}
                                            handleSetValues={handleSetValues}
                                        ></GoogleMaps>
                                    </Grid>
                                    <Grid item mb={1} xs={12} md={6}>
                                        <FormControl fullWidth required={true}>
                                            <InputLabel id="demo-simple-select-label">
                                                Installer
                                            </InputLabel>
                                            <Select
                                                id="user_id"
                                                name="user_id"
                                                label="Installer"
                                                required
                                                value={license.user_id}
                                                onChange={(e) =>
                                                    handelUpdataLicenseForm(
                                                        e,
                                                        index
                                                    )
                                                }
                                            >
                                                {installersVal?.map((key) => (
                                                    <MenuItem
                                                        key={key.id}
                                                        value={key.id}
                                                    >
                                                        {key.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item mb={1} xs={12} md={6}>
                                        <Typography
                                            variant="lable"
                                            id="document"
                                            label="document"
                                            align="justify"
                                        >
                                            <Avatar
                                                alt="Upload Document"
                                                src={uploadImage}
                                                sx={{
                                                    width: "7em",
                                                    height: "7em",
                                                    margin: "auto",
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontWeight: "700",
                                                    color: "#888",
                                                }}
                                                variant="h6"
                                                align="center"
                                            >
                                                Licence Docs
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#888",
                                                }}
                                                variant="h6"
                                                align="center"
                                            >
                                                Any assets used in projects will
                                                live here.
                                                <br></br>
                                                Start creating by uploading your
                                                files.
                                            </Typography>
                                        </Typography>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            component="label"
                                        >
                                            <CloudUpload />
                                            <span mr={2} ml={2}>
                                                Upload
                                            </span>
                                            <input
                                                hidden
                                                type="file"
                                                name="license_img"
                                                id="license_img"
                                                onChange={(e) =>
                                                    handleChangeImage(e, index)
                                                }
                                            />
                                        </Button>
                                    </Grid>

                                    <Grid item mb={1} xs={12} md={6}>
                                        <Typography
                                            variant="lable"
                                            id="document"
                                            label="document"
                                            align="justify"
                                        >
                                            <Avatar
                                                alt="Upload Document"
                                                src={uploadImage}
                                                sx={{
                                                    width: "7em",
                                                    height: "7em",
                                                    margin: "auto",
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontWeight: "700",
                                                    color: "#888",
                                                }}
                                                variant="h6"
                                                align="center"
                                            >
                                                Drivers License
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#888",
                                                }}
                                                variant="h6"
                                                align="center"
                                            >
                                                Any assets used in projects will
                                                live here.
                                                <br></br>
                                                Start creating by uploading your
                                                files.
                                            </Typography>
                                        </Typography>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            component="label"
                                        >
                                            <CloudUpload />
                                            <span mr={2} ml={2}>
                                                Upload
                                            </span>
                                            <input
                                                hidden
                                                type="file"
                                                name="drivers_license"
                                                id="drivers_license"
                                                onChange={(e) =>
                                                    handleChangeImage(e, index)
                                                }
                                            />
                                        </Button>
                                    </Grid>

                                    <Grid item mb={1} xs={12} md={6}>
                                        <Typography
                                            variant="lable"
                                            id="document"
                                            label="document"
                                            align="justify"
                                        >
                                            <Avatar
                                                alt="Upload Document"
                                                src={uploadImage}
                                                sx={{
                                                    width: "7em",
                                                    height: "7em",
                                                    margin: "auto",
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontWeight: "700",
                                                    color: "#888",
                                                }}
                                                variant="h6"
                                                align="center"
                                            >
                                                Workers Comp Insurance
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#888",
                                                }}
                                                variant="h6"
                                                align="center"
                                            >
                                                Any assets used in projects will
                                                live here.
                                                <br></br>
                                                Start creating by uploading your
                                                files.
                                            </Typography>
                                        </Typography>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            component="label"
                                        >
                                            <CloudUpload />
                                            <span mr={2} ml={2}>
                                                Upload
                                            </span>
                                            <input
                                                hidden
                                                type="file"
                                                name="workers_comp_insurance"
                                                id="workers_comp_insurance"
                                                onChange={(e) =>
                                                    handleChangeImage(e, index)
                                                }
                                            />
                                        </Button>
                                    </Grid>

                                    <Grid item mb={1} xs={12} md={6}>
                                        <Typography
                                            variant="lable"
                                            id="document"
                                            label="document"
                                            align="justify"
                                        >
                                            <Avatar
                                                alt="Upload Document"
                                                src={uploadImage}
                                                sx={{
                                                    width: "7em",
                                                    height: "7em",
                                                    margin: "auto",
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontWeight: "700",
                                                    color: "#888",
                                                }}
                                                variant="h6"
                                                align="center"
                                            >
                                                Liability Insurance
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#888",
                                                }}
                                                variant="h6"
                                                align="center"
                                            >
                                                Any assets used in projects will
                                                live here.
                                                <br></br>
                                                Start creating by uploading your
                                                files.
                                            </Typography>
                                        </Typography>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            component="label"
                                        >
                                            <CloudUpload />
                                            <span mr={2} ml={2}>
                                                Upload
                                            </span>
                                            <input
                                                hidden
                                                type="file"
                                                name="liability_insurance"
                                                id="liability_insurance"
                                                onChange={(e) =>
                                                    handleChangeImage(e, index)
                                                }
                                            />
                                        </Button>
                                    </Grid>
                                    <Grid
                                        item
                                        mb={1}
                                        xs={12}
                                        md={6}
                                        className="display"
                                    >
                                        <Button
                                            fullWidth
                                            color="error"
                                            variant="contained"
                                            onClick={(e) =>
                                                handelDeleteLicenseForm(index)
                                            }
                                        >
                                            <Delete />
                                            Delete
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Card>
                        ))}
                        <Grid countainer mt={2}>
                            <Button
                                mt={4}
                                variant="contained"
                                color="success"
                                style={{ float: "right", width: "40%" }}
                                onClick={(e) => handelAddMoreLicenseForms()}
                            >
                                <Add /> Add More License
                            </Button>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading ... " : "Save"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;

const DivParant = styled.div`
    display: flex;
`;
export default BussinessLicense;
